module.exports = __webpack_public_path__ + "img/certificate-CU-LD.eb556fc4.jpg";